import React, { useState } from 'react';
import FavouriteButton from '../Components/FavouriteButton';

export default function FavouriteButtonContainer(props) {
    const { articleNumber } = props;

    return (
        <>
            <FavouriteButton {...{articleNumber : articleNumber}}/>
        </>
    )
}